<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "EinarbeitungList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Einarbeitung"
      new-button-name="Neue(s) Dokument/Information"
      :list-header="tableHeader"
      :category=7
      :event-to-call-options="{
        table: tableItems,
        showPath: 'Einarbeitung',
        redirectPath: 'EinarbeitungEdit',
        categoryId: 7,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'einarbeitung'
      }"
   new-button-path="EinarbeitungNew"></CMSListCard>
</template>

<style scoped>

</style>
